import React, { useEffect, useState, useRef } from "react";
import DashboardWrapper from "../../layout/index";
import getLeaderBoardList, { getDashboardKpiData ,fetchDashboardDataa } from "../../api/dashobard";
import LeaderTable from "../../components/LeaderTable";
import Loader from "../../components/Loader";
import Dropdown from "../../components/Dropdown";
import { formatCurrentEndDate, formatCurrentStartDate } from "../../utility";
import { preseller, salesman ,dd_supervisor } from "../../utility/constant";
import { getGlobalFilter } from "../../api/filters";
import TimeFrameSelector from "../../components/TimeFrameSelector";
import { formatDate } from "../../utility";
import { useLocation } from "react-router-dom";
import Filter from "../../assets/icons/Filter.svg";
import Close from "../../assets/close-circle.svg";
import WaterLogo from "../../assets/logo.svg";
import SnacksLogo from "../../assets/snacks.png";
import Channel1060 from "./Channel1060";
import Channel50 from "./Channel50";
import Channel20 from "./Channel20";
import Channel40 from "./Channel40";
import { useTranslation } from "react-i18next";
import DropdownMulti from "../../components/DropdownMultiple";
import { getUserInfo } from "../../utility";
import { useDateRangeSelector } from "../../components/DateRangeSelector";

const Dashboard = () => {
  const [leaderData, setLeaderData] = useState<any>([]);
  const [leaderDataList, setLeaderDataList] = useState<any>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [startDate, setStartDate] = useState<any | undefined>(getCurrentDate());
  const [endDate, setEndDate] = useState<any | undefined>(getCurrentDate());
  const [dateMode, setDateMode] = useState<"picker" | "quarter" | "month">("picker");
  
  // Use the reusable date range selector hook
  const dateRangeSelector = useDateRangeSelector(2024);
  const [dashobardData, setDashboardData] = useState<any>([]);
  const [dashboardDataa ,setDashboardDataa] = useState<any>([]);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [dataLoader, setDataLoader] = useState<boolean>(false);
  const { t, i18n } = useTranslation();
  const [globalFilters, setGlobalFilters] = useState<any>(null);
  const [salesOffice, setSelectedSalesOffice] = useState<any[]>([]);
  const [salesRegion, setSelectedSalesRegion] = useState<any>([]);
  const [timeFrame, setSelectTimeFrame] = useState<any>("Today");
  const [regionList, setRegionList] = useState<any>([]);
  const location = useLocation();
  const [emp, setEmployee] = useState<any>(
    location.state ? Array(location.state) : []
  );
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [channel, setChannel] = useState<any>("");
  const [channelId, setChannelId] = useState<any>("");
  const [teretorryId, setTeretorryId] = useState<any[]>([]);
  const scrollContainerRef = useRef(null);
  const [loadingFilter, setLoadingFilter] = useState<boolean>(false);
  const [selectedEmpStatus, setSelectedEmpStatus] = useState<any>("");
  const [userType, setUserType] = useState<any>("");
  const [supervisorId, setSupervisorId] = useState<any>("");
  const avoidLeaderBoardCall = useRef(false);
  const defaultChannel = 20;
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [supervisorList, setSupervisorList] = useState<any[]>([]);
  const [lastUpperFilters, setLastUpperFilters] = useState<{ salesRegion: any[]; salesOffice: any; channelId: any }>({ salesRegion: [], salesOffice: [], channelId: '' });
  const [filteredEmployees, setFilteredEmployees] = useState<any[]>([]);
  const [dashboardDataaLoading, setDashboardDataaLoading] = useState<boolean>(false);
  const [liveTodayDashboardData, setLiveTodayDashboardData] = useState<any>(null);
  const [kpiViewMode, setKpiViewMode] = useState<"all" | "water" | "snacks">("water");
  const [appliedFilters, setAppliedFilters] = useState<{
    startDate: string;
    endDate: string;
    timeFrame: string;
  }>({
    startDate: getCurrentDate(),
    endDate: getCurrentDate(),
    timeFrame: "Today"
  });
  const [isInitialMount, setIsInitialMount] = useState(true);

  const toggleLeaderboard = () => {
    setIsCollapsed(!isCollapsed);
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 200);
  };

  function getCurrentDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  // Unified handler for date/timeFrame changes that only updates state
  const handleDateOrTimeFrameFilterUpdate = (newStartDate?: string, newEndDate?: string, newTimeFrame?: string) => {
    if (newStartDate !== undefined) setStartDate(newStartDate);
    if (newEndDate !== undefined) setEndDate(newEndDate);
    if (newTimeFrame !== undefined) setSelectTimeFrame(newTimeFrame);
    // Do NOT call handleFiltersUpdate here
  };

  // Add useEffect to call handleFiltersUpdate when date/timeFrame changes and filter popup is open
  React.useEffect(() => {
    if (open) {
      handleFiltersUpdate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate, timeFrame]);

  // Helper to call global filter API with up-to-date values
  function callGlobalFilterWithDates(start: string, end: string, tf: string) {
    const data: any = {};
    if (start) data["start_date"] = formatCurrentStartDate(new Date(start));
    if (end) data["end_date"] = formatCurrentEndDate(new Date(end));
    if (salesRegion.length > 0) data["regions"] = salesRegion;
    if (salesOffice.length > 0) data["sales_office_ids"] = salesOffice;
    if (channelId) data["channel_ids"] = channelId;
    data["endpoint"] = "visit-summary";
    data["positions"] = [preseller, salesman, dd_supervisor];
    getGlobalFilters(data);
  }

  // Update: handleStartDateChange and handleEndDateChange to call global filter directly
  const handleStartDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDateMode("picker");
    const newStartDate = e.target.value;
    const startDateObj = new Date(newStartDate);
    const endDateObj = new Date(endDate);
    
    // If start date is after end date, adjust end date to be 30 days after start date
    if (startDateObj > endDateObj) {
      const adjustedEndDate = new Date(startDateObj);
      adjustedEndDate.setDate(startDateObj.getDate() + 30);
      setEndDate(adjustedEndDate.toISOString().split("T")[0]);
      checkTimeFrame(newStartDate, adjustedEndDate.toISOString().split("T")[0]);
      setStartDate(newStartDate);
      // Only call global filter if not in initial mount
      if (!isInitialMount) {
        callGlobalFilterWithDates(newStartDate, adjustedEndDate.toISOString().split("T")[0], timeFrame);
      }
      return;
    }
    
    // Calculate the difference in days
    const timeDiff = endDateObj.getTime() - startDateObj.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    
    // If the range exceeds 31 days, adjust the end date to maintain 31-day constraint
    if (daysDiff > 31) {
      const adjustedEndDate = new Date(startDateObj);
      adjustedEndDate.setDate(startDateObj.getDate() + 30);
      setEndDate(adjustedEndDate.toISOString().split("T")[0]);
      checkTimeFrame(newStartDate, adjustedEndDate.toISOString().split("T")[0]);
    } else {
      checkTimeFrame(newStartDate, endDate);
    }
    
    setStartDate(newStartDate);
    // Only call global filter if not in initial mount
    if (!isInitialMount) {
      callGlobalFilterWithDates(newStartDate, endDate, timeFrame);
    }
  };

  const handleEndDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDateMode("picker");
    const newEndDate = e.target.value;
    const startDateObj = new Date(startDate);
    const endDateObj = new Date(newEndDate);
    
    // If end date is before start date, adjust start date to be 30 days before end date
    if (endDateObj < startDateObj) {
      const adjustedStartDate = new Date(endDateObj);
      adjustedStartDate.setDate(endDateObj.getDate() - 30);
      setStartDate(adjustedStartDate.toISOString().split("T")[0]);
      checkTimeFrame(adjustedStartDate.toISOString().split("T")[0], newEndDate);
      setEndDate(newEndDate);
      // Only call global filter if not in initial mount
      if (!isInitialMount) {
        callGlobalFilterWithDates(adjustedStartDate.toISOString().split("T")[0], newEndDate, timeFrame);
      }
      return;
    }
    
    // Calculate the difference in days
    const timeDiff = endDateObj.getTime() - startDateObj.getTime();
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    
    // If the range exceeds 31 days, adjust the start date to maintain 31-day constraint
    if (daysDiff > 31) {
      const adjustedStartDate = new Date(endDateObj);
      adjustedStartDate.setDate(endDateObj.getDate() - 30);
      setStartDate(adjustedStartDate.toISOString().split("T")[0]);
      checkTimeFrame(adjustedStartDate.toISOString().split("T")[0], newEndDate);
    } else {
      checkTimeFrame(startDate, newEndDate);
    }
    
    setEndDate(newEndDate);
    // Only call global filter if not in initial mount
    if (!isInitialMount) {
      callGlobalFilterWithDates(startDate, newEndDate, timeFrame);
    }
  };

  // Clear only date-related filters (quarter / month / normal) and reset to Today
  const handleClearDateFilters = () => {
    const today = getCurrentDate();
    // Reset internal selector state
    dateRangeSelector.reset();
    // Reset main date state
    setStartDate(today);
    setEndDate(today);
    setDateMode("picker");
    setSelectTimeFrame("Today");
    checkTimeFrame(today, today);
    if (!isInitialMount) {
      callGlobalFilterWithDates(today, today, "Today");
    }
  };

  // Handlers using the reusable date range selector hook
  const applyYearQuarter = (yearVal: number, quarterVal: string) => {
    if (!yearVal || !quarterVal) return;
    dateRangeSelector.setSelectedMonth(""); // Reset month when quarter is selected
    const { start, end } = dateRangeSelector.getQuarterRange(yearVal, quarterVal);
    const newStartStr = formatDate(start);
    const newEndStr = formatDate(end);
    setStartDate(newStartStr);
    setEndDate(newEndStr);
    // Quarter selection should behave as a multi-day range, not a single-day preset
    setSelectTimeFrame("");
    setDateMode("quarter");
    callGlobalFilterWithDates(newStartStr, newEndStr, timeFrame);
  };

  const handleYearDropdownChange = (value: string | number) => {
    const yearNum = Number(value);
    dateRangeSelector.setSelectedYear(yearNum);
    applyYearQuarter(yearNum, dateRangeSelector.selectedQuarter);
  };

  const handleQuarterDropdownChange = (value: string | number) => {
    const quarterStr = String(value);
    dateRangeSelector.setSelectedQuarter(quarterStr);
    if (dateRangeSelector.selectedYear) {
      applyYearQuarter(Number(dateRangeSelector.selectedYear), quarterStr);
    }
  };

  const applyYearMonth = (yearVal: number, monthVal: number) => {
    if (!yearVal || !monthVal) return;
    dateRangeSelector.setSelectedQuarter(""); // Reset quarter when month is selected
    dateRangeSelector.setSelectedYear(""); // Clear quarter year so quarter UI resets
    const { start, end } = dateRangeSelector.getMonthRange(yearVal, monthVal);
    const newStartStr = formatDate(start);
    const newEndStr = formatDate(end);
    setStartDate(newStartStr);
    setEndDate(newEndStr);
    // Month-year selection should behave as a multi-day range, not a single-day preset
    setSelectTimeFrame("");
    setDateMode("month");
    callGlobalFilterWithDates(newStartStr, newEndStr, timeFrame);
  };

  const handleMonthYearDropdownChange = (value: string | number) => {
    const yearNum = Number(value);
    dateRangeSelector.setSelectedMonthYear(yearNum);
    // Clear month selection if year changes and current month is invalid for new year
    if (dateRangeSelector.selectedMonth) {
      const monthNum = Number(dateRangeSelector.selectedMonth);
      // If selected year is current year and selected month is in the future, clear month
      if (yearNum === dateRangeSelector.currentYear && monthNum > dateRangeSelector.currentMonth) {
        dateRangeSelector.setSelectedMonth("");
      } else {
        applyYearMonth(yearNum, monthNum);
      }
    }
  };

  const handleMonthDropdownChange = (value: string | number) => {
    const monthNum = Number(value);
    dateRangeSelector.setSelectedMonth(String(monthNum));
    if (dateRangeSelector.selectedMonthYear) {
      applyYearMonth(Number(dateRangeSelector.selectedMonthYear), monthNum);
    }
  };

  const getGlobalFilters = async (data: any) => {
    try {
      if (loadingFilter) {
        return;
      }
      setLoadingFilter(true);
      const response = await getGlobalFilter(data);
      setGlobalFilters(response);
      // Update supervisorList only when upper filters change
      const supervisors = response?.employees?.filter((emp: any) => emp.position === "DD Supervisor") || [];
      setSupervisorList(supervisors);
      const exists = response?.channels?.some(
        (item: any) => Number(item.id) === defaultChannel
      );
      if (exists) {
        setChannel(defaultChannel);
      } else {
        setChannel(Number(response?.channels[0]?.id));
      }
    } catch (error) {
      console.error("Error fetching global filters:", error);
    } finally {
      setLoadingFilter(false);
    }
  };

  function getDefaultChannel() {
    const userInfo = getUserInfo();
    const allowedChannels = userInfo?.channel_ids || [];
    if (!allowedChannels || allowedChannels.length === 0) {
      return "20";
    }
    if (allowedChannels.includes("20") || allowedChannels.includes(20)) {
      return "20";
    }
    return String(allowedChannels[0]);
  }

  function getChannelIdsForPayload(selectedChannelId: any) {
    if (selectedChannelId) {
      return [String(selectedChannelId)];
    }
    return [getDefaultChannel()];
  }

  const handleClearFilters = () => {
    const defaultChannel = getDefaultChannel();
    setChannelId(defaultChannel);
    setChannel(Number(defaultChannel));
    setSelectedSalesRegion([]);
    setEmployee([]);
    setRegionList([]);
    setSelectedSalesOffice([]);
    setStartDate(getCurrentDate());
    setEndDate(getCurrentDate());
    dateRangeSelector.reset();
    setDateMode("picker");
    setUserType("");
    setSelectedEmpStatus("");
    setSelectTimeFrame("Today");
    setTeretorryId([]);
    // Reset applied filters
    setAppliedFilters({
      startDate: getCurrentDate(),
      endDate: getCurrentDate(),
      timeFrame: "Today"
    });
    handleClearApply(getCurrentDate(), getCurrentDate());
    setSupervisorId("");
  };

  const handleClearApply = (startDate: string, endDate: string) => {
    setOpen(false);
    // Update applied filters when Clear is clicked
    setAppliedFilters({
      startDate,
      endDate,
      timeFrame: "Today"
    });
    
    const data: any = {};
    if (startDate) {
      data["start_date"] = formatCurrentStartDate(new Date(startDate));
    }
    if (endDate) {
      data["end_date"] = formatCurrentEndDate(new Date(endDate));
    }
    data["positions"] = [preseller,salesman];
    getDashboardData(data);
    setTimeout(() => getDashboardDataa(data), 0); // decoupled, never blocks UI
    setChannel(defaultChannel);
    const param = {
      page: 1,
      size: 15,
    };
    setCurrentPage(1);
    const dataLeader: any = {};
    if (startDate) {
      dataLeader["start_date"] = formatCurrentStartDate(new Date(startDate));
    }
    if (endDate) {
      dataLeader["end_date"] = formatCurrentEndDate(new Date(endDate));
    }
    dataLeader["positions"] = [preseller,salesman];
    getLeaderBoardData(param, dataLeader);
  };

  const getIndex = (data: any, index: any) => {
    return Number(index + 1);
  };

  const getDashboardData = async (data: any) => {
    setDataLoader(true);
    const payload = { ...data, channel_ids: getChannelIdsForPayload(channelId) };
    const isTodayRequest =
      data.start_date === formatCurrentStartDate(new Date()) &&
      data.end_date === formatCurrentEndDate(new Date());
    await getDashboardKpiData(payload)
      .then((res) => {
        setDashboardData(res.data);
        if (
          payload.channel_ids &&
          (payload.channel_ids.includes("20") || payload.channel_ids.includes(20)) &&
          isTodayRequest
        ) {
          setLiveTodayDashboardData(res.data);
        }
        setDataLoader(false);
        setChannel(Number(payload.channel_ids[0]));
      })
      .catch((error) => {
        setDataLoader(false);
        console.log(error);
      });
  };

  const fetchLiveTodayDashboardData = async (baseData: any) => {
    const todayPayload = {
      ...baseData,
      start_date: formatCurrentStartDate(new Date()),
      end_date: formatCurrentEndDate(new Date()),
      channel_ids: getChannelIdsForPayload(channelId),
    };
    try {
      const res = await getDashboardKpiData(todayPayload);
      setLiveTodayDashboardData(res.data);
    } catch (error) {
      console.log(error);
    }
  };
  const getDashboardDataa = async (data: any) => {
    setDashboardDataaLoading(true);
    const payload = { ...data, channel_ids: getChannelIdsForPayload(channelId) };
    await fetchDashboardDataa(payload)
      .then((res) => {
        setDashboardDataa(res.data);
        setDashboardDataaLoading(false);
        setChannel(Number(payload.channel_ids[0]));
      })
      .catch((error) => {
        setDashboardDataaLoading(false);
        console.log(error);
      });
  };

  const getLeaderBoardData = async (param: any, data: any) => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    const payload = { ...data, channel_ids: getChannelIdsForPayload(channelId) };
    await getLeaderBoardList(param, payload)
      .then((res) => {
        setLeaderData(res.data);
        setIsLoading(false);
        if (currentPage === 1) {
          setLeaderDataList(res.data.items);
        } else {
          setLeaderDataList((prevData: any) => [
            ...prevData,
            ...res.data.items,
          ]);
        }
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleFiltersUpdate = () => {
    // Check if upper filters changed
    const upperFiltersChanged =
      JSON.stringify(salesRegion) !== JSON.stringify(lastUpperFilters.salesRegion) ||
      JSON.stringify(salesOffice) !== JSON.stringify(lastUpperFilters.salesOffice) ||
      channelId !== lastUpperFilters.channelId;

    if (upperFiltersChanged) {
      // Update lastUpperFilters
      setLastUpperFilters({ salesRegion: [...salesRegion], salesOffice: [...salesOffice], channelId });
      // Prepare data for global filters
      const data: any = {};
      if (salesRegion.length > 0) {
        data["regions"] = salesRegion;
      }
      if (salesOffice.length > 0) {
        data["sales_office_ids"] = salesOffice;
      }
      if (channelId) {
        data["channel_ids"] = channelId;
      }
      data["endpoint"] = "visit-summary";
      data["start_date"] = formatCurrentStartDate(new Date(startDate));
      data["end_date"] = formatCurrentEndDate(new Date(endDate));
      data["positions"] = [preseller, salesman, dd_supervisor];
      getGlobalFilters(data);
    } else {
      // Only lower filters changed, do not update supervisorList/globalFilters
      // You may want to trigger employee filtering logic here if needed
    }
  };

  useEffect(() => {
    // Initialize default channel first
    const defaultChannel = getDefaultChannel();
    setChannelId(defaultChannel);
    setChannel(Number(defaultChannel));

    // Prepare initial data payload with the default channel
    const data: any = {};
    if (startDate) {
      data["start_date"] = formatCurrentStartDate(new Date(startDate));
    }
    if (endDate) {
      data["end_date"] = formatCurrentEndDate(new Date(endDate));
    }
    if (salesOffice.length > 0) {
      data["sales_office_ids"] = salesOffice;
    }
    // Use the default channel directly instead of channelId state
    data["channel_ids"] = [defaultChannel];
    if (salesRegion.length > 0) {
      data["regions"] = salesRegion;
    }
    if (emp.length > 0) {
      data["subordinate_ids"] = emp;
    }
    if (userType) {
      data["user_type"] = userType;
    }
    data["positions"] = [preseller, salesman];

    // Call dashboard APIs only once
    getDashboardData(data);
    getDashboardDataa(data);

    // Prepare data for global filters
    const globalFilterData: any = {};
    if (salesRegion.length > 0) {
      globalFilterData["regions"] = salesRegion;
    }
    if (salesOffice.length > 0) {
      globalFilterData["sales_office_ids"] = salesOffice;
    }
    if (emp) {
      globalFilterData["subordinate_ids"] = emp;
    }
    if (teretorryId.length > 0) {
      globalFilterData["territory_ids"] = teretorryId;
    }
    globalFilterData["endpoint"] = "dashboard";
    globalFilterData["start_date"] = formatCurrentStartDate(new Date(startDate));
    globalFilterData["end_date"] = formatCurrentEndDate(new Date(endDate));
    globalFilterData["positions"] = [preseller, salesman, dd_supervisor];
    
    // Call global filters only once
    getGlobalFilters(globalFilterData);

    // Mark initial mount as complete
    setIsInitialMount(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleApply = (value: any) => {
    setOpen(false);
    // Update applied filters when Apply is clicked
    setAppliedFilters({
      startDate,
      endDate,
      timeFrame
    });
    
    const data: any = {};
    if (startDate) {
      data["start_date"] = formatCurrentStartDate(new Date(startDate));
    }
    if (startDate) {
      data["end_date"] = formatCurrentEndDate(new Date(endDate));
    }
    if (salesOffice.length > 0) {
      data["sales_office_ids"] = salesOffice;
    }
    if (salesRegion.length > 0) {
      data["regions"] = salesRegion;
    }
    if (selectedEmpStatus) {
      data["status"] = selectedEmpStatus;
    }
    if (value) {
      data["subordinate_ids"] = value;
    }
    if (supervisorId) {
      data["supervisor_ids"] = supervisorId
    }
    if (userType) {
      data["user_type"] = userType;
    }
    if (teretorryId.length > 0) {
      data["territory_ids"] = teretorryId;
    }
    data["positions"] = [preseller, salesman];
    const isSingleDay =
      timeFrame === "Today" || timeFrame === "Yesterday" || startDate === endDate;
    if (!isSingleDay) {
      setLiveTodayDashboardData(null);
    } else if (
      (channelId === "20" || channelId === 20 || channel === 20) &&
      (startDate !== getCurrentDate() || endDate !== getCurrentDate())
    ) {
      fetchLiveTodayDashboardData(data);
    }
    getDashboardData(data);
    setTimeout(() => getDashboardDataa(data), 0); // decoupled, never blocks UI
    // Leaderboard logic (if needed)
    const param = {
      page: 1,
      size: 15,
    };
    setCurrentPage(1);
    const dataLeader: any = { ...data };
    getLeaderBoardData(param, dataLeader);
  };

  // useEffect(() => {
  //   if (emp.length > 0) {
  //     handleApply(true);
  //   }
  // }, [emp]);

  useEffect(() => {
    // Run only when status actually changes after initial load
    if (isInitialMount) return;
    setEmployee([]);
    handleApply(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedEmpStatus]);

  useEffect(() => {
    // Only run after initial mount to prevent duplicate API calls
    if (!isInitialMount) {
      const param = {
        page: currentPage,
        size: 15,
      };

      const data: any = {};

      if (startDate) {
        data["start_date"] = formatCurrentStartDate(new Date(startDate));
      }
      if (endDate) {
        data["end_date"] = formatCurrentEndDate(new Date(endDate));
      }
      if (salesOffice.length > 0) {
        data["sales_office_ids"] = salesOffice;
      }
      if (channelId) {
        data["channel_ids"] = channelId;
      }
      if (salesRegion.length > 0) {
        data["regions"] = salesRegion;
      }
      if (selectedEmpStatus) {
        data["status"] = selectedEmpStatus;
      }
      if (emp) {
        data["subordinate_ids"] = emp;
      }
      if (userType) {
        data["user_type"] = userType;
      }
      data["positions"] = [preseller, salesman];
      getLeaderBoardData(param, data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, isInitialMount]);

  useEffect(() => {
    // Only run after initial mount to prevent duplicate API calls
    if (!isInitialMount) {
      if (emp) {
        globalFilters?.employees?.map((value: any) => {
          if (emp === value.id) {
            setUserType(value.position);
          }
        });
      } else {
        setUserType("");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [emp, isInitialMount]);

  useEffect(() => {
    // Only run after initial mount to prevent duplicate API calls
    if (!isInitialMount) {
      if (globalFilters?.employees) {
        if (supervisorId) {
          setFilteredEmployees(
            globalFilters.employees.filter((emp: any) => String(emp.id) !== String(supervisorId))
          );
        } else {
          setFilteredEmployees(globalFilters.employees);
        }
      } else {
        setFilteredEmployees([]);
      }
    }
  }, [supervisorId, globalFilters, isInitialMount]);

  const handleEmployeeClick = (emp_id: any) => {
    if (emp_id[0] === emp[0]) {
      setEmployee([])
      handleApply(null)
    } else {
      avoidLeaderBoardCall.current = true
      handleApply(emp_id)
      setEmployee(emp_id)
      setTimeout(() => {
        avoidLeaderBoardCall.current = false
      }, 500);
    }

  }

  useEffect(() => {
    // Only run after initial mount to prevent duplicate API calls
    if (!isInitialMount) {
      setSelectedSalesOffice([]);
      setTeretorryId([]);
      setEmployee([]);
      setSupervisorId("");
    }
  }, [salesRegion, isInitialMount]);

  useEffect(() => {
    // Only run after initial mount to prevent duplicate API calls
    if (!isInitialMount) {
      setTeretorryId([]);
      setEmployee([]);
      setSupervisorId("");
    }
  }, [salesOffice, isInitialMount]);

  useEffect(() => {
    // Only run after initial mount to prevent duplicate API calls
    if (!isInitialMount) {
      setChannelId("");
      setEmployee([]);
      setSupervisorId("");
    }
  }, [teretorryId, isInitialMount]);

  useEffect(() => {
    // Only run after initial mount to prevent duplicate API calls
    if (!isInitialMount) {
      // This effect handles both selecting and deselecting a supervisor.
      setEmployee([]); // Clear employee selection whenever supervisor changes.

      const data: any = {};
      if (salesRegion.length > 0) {
        data["regions"] = salesRegion;
      }
      if (salesOffice.length > 0) {
        data["sales_office_ids"] = salesOffice;
      }
      if (channelId) {
        data["channel_ids"] = channelId;
      }
      data["endpoint"] = "visit-summary";
      data["start_date"] = formatCurrentStartDate(new Date(startDate));
      data["end_date"] = formatCurrentEndDate(new Date(endDate));
      
      if (supervisorId) {
        // Supervisor is SELECTED. Fetch their employees.
        data["supervisor_ids"] = supervisorId;
        data["positions"] = [preseller, salesman, dd_supervisor]; // Include all positions in request
        
        // Call API directly, do not update supervisorList
        getGlobalFilter(data).then((response: any) => {
          setGlobalFilters(response);
        });
      } else {
        // Supervisor is DESELECTED. Fetch all employees for current filters.
        data["positions"] = [preseller, salesman, dd_supervisor];
        
        // Call the main wrapper function to update everything, including supervisorList.
        getGlobalFilters(data);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supervisorId, isInitialMount]);

  const checkTimeFrame = (start: any, end: any) => {
    if (start === formatDate(new Date()) && end === formatDate(new Date())) {
      setSelectTimeFrame("Today");
    } else if (
      start === formatDate(new Date().setDate(new Date().getDate() - 1)) &&
      end === formatDate(new Date().setDate(new Date().getDate() - 1))
    ) {
      setSelectTimeFrame("Yesterday");
    } else if (
      start === formatDate(new Date().setDate(1)) &&
      end === formatDate(new Date())
    ) {
      setSelectTimeFrame("Month Till Date");
    } else {
      setSelectTimeFrame("");
    }
  };

  return (
    <DashboardWrapper className="fixed-dashboard-wrapper">
      <div className="bg-white"></div>

      {dataLoader && (
        <div className="absolute top-[50%] left-[50%] z-50">
          <Loader />
          <p>Loading Please Wait...</p>
        </div>
      )}

      <div className={`flex gap-5 pb-0 md:pb-0 p-4 md:p-3 w-full lg:flex-row flex-col`} style={dataLoader ? { filter: 'blur(5px)' } : {}}>

        <div className={`${isCollapsed ? 'lg:w-full' : 'lg:w-[63%]'} w-full transition-all duration-300`}>
          <div className="flex justify-between items-center">
            <div className="flex flex-col gap-1 pl-1 pb-3 text-13 font-medium">
              <p>{t("DashboardAnalytics.reportTitle")}</p>
              <p className="text-[20px] font-semibold">
                {dateMode === "quarter" || dateMode === "month" ? (
                  startDate?.split("-").reverse().join("-") +
                  " To " +
                  endDate?.split("-").reverse().join("-")
                ) : timeFrame ? (
                  <>
                    {timeFrame === "Today" && t("DashboardAnalytics.today")}
                    {timeFrame === "Yesterday" && t("timeframeselector.yesterday")}
                    {timeFrame === "Month Till Date" && t("DashboardAnalytics.monthtilldate")}
                  </>
                ) : (
                  startDate?.split("-").reverse().join("-") +
                  " To " +
                  endDate?.split("-").reverse().join("-")
                )}
              </p>
            </div>
            <div className="flex items-center gap-2">
              {channel === 20 && (
                <div className="w-[250px]">
                  <Dropdown
                    label="Category"
                    options={[
                      { value: "all", label: "All", searchText: "all" },
                      {
                        value: "water",
                        label: (
                          <span className="flex items-center gap-2">
                            <img src={WaterLogo} alt="" className="w-8 h-8 object-contain" />
                            <span>Water</span>
                          </span>
                        ),
                        searchText: "water",
                      },
                      {
                        value: "snacks",
                        label: (
                          <span className="flex items-center gap-2">
                            <img src={SnacksLogo} alt="" className="w-8 h-8 object-contain" />
                            <span>Snacks</span>
                          </span>
                        ),
                        searchText: "snacks",
                      },
                    ]}
                    selectedValue={kpiViewMode}
                    onChange={(value) =>
                      setKpiViewMode(value as "all" | "water" | "snacks")
                    }
                    placeholder="KPI View"
                  />
                </div>
              )}
              <button
                className={`flex items-center px-4 p-3 gap-2 bg-[#FAFAFA] border-2 border-[#EBEBEB] ${dataLoader || loadingFilter || isLoading || dashboardDataaLoading ? 'opacity-50 cursor-not-allowed' : ''}`}
                onClick={() => setOpen(true)}
                disabled={dataLoader || loadingFilter || isLoading || dashboardDataaLoading}
              >
                <img src={Filter} alt="" />{" "}
                {t("DashboardAnalytics.filterButton")}
              </button>
            </div>
          </div>

          {channel === 20 && <Channel20 dashobardData={dashobardData} liveTodayVisitMetrics={liveTodayDashboardData?.visit_metrics} status={selectedEmpStatus} setStatus={setSelectedEmpStatus} dashboardDataa={dashboardDataa} dashboardDataaLoading={dashboardDataaLoading} startDate={appliedFilters.startDate} endDate={appliedFilters.endDate} timeFrame={appliedFilters.timeFrame} kpiViewMode={kpiViewMode} />}
          {(channel === 10 || channel === 60) && (
            <Channel1060 dashobardData={dashobardData} status={selectedEmpStatus} setStatus={setSelectedEmpStatus} dashboardDataa={dashboardDataa} dashboardDataaLoading={dashboardDataaLoading} startDate={appliedFilters.startDate} endDate={appliedFilters.endDate} timeFrame={appliedFilters.timeFrame} />
          )}
          {channel === 50 && <Channel50 dashobardData={dashobardData} status={selectedEmpStatus} setStatus={setSelectedEmpStatus} dashboardDataa={dashboardDataa} dashboardDataaLoading={dashboardDataaLoading} startDate={appliedFilters.startDate} endDate={appliedFilters.endDate} timeFrame={appliedFilters.timeFrame} />}
          {channel === 40 && <Channel40 dashobardData={dashobardData} status={selectedEmpStatus} setStatus={setSelectedEmpStatus} dashboardDataa={dashboardDataa} dashboardDataaLoading={dashboardDataaLoading} startDate={appliedFilters.startDate} endDate={appliedFilters.endDate} timeFrame={appliedFilters.timeFrame} />}
        </div>

        {open && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-end sm:items-start items-center z-50">
            <div className="bg-white shadow-lg w-full max-w-md h-full">
              <div className="flex justify-between p-6 border-b-2">
                <div className="text-16 font-bold">
                  {t("DashboardAnalytics.filtersTitle")}
                </div>
                <div>
                  <img
                    className="cursor-pointer"
                    onClick={() => setOpen(false)}
                    src={Close}
                    alt=""
                  />
                </div>
              </div>
              <div className="flex flex-col justify-between h-[calc(100vh-100px)] px-12 pt-6  overflow-y-auto">
                <div className="relative flex flex-col gap-[30px]">
                  <div className="absolute z-30 top-[50%] left-[45%]">
                    {loadingFilter && <Loader />}
                  </div>
                  <div className="flex flex-col sm:flex-row gap-4 w-full">
                    <div className="w-1/2">
                      <DropdownMulti
                        label={t("visitreports.filters.region")}
                        options={globalFilters?.regions.map((sales: any) => ({
                          value: sales,
                          label: sales,
                        }))}
                        selectedValues={salesRegion}
                        onClose={handleFiltersUpdate}
                        onChange={setSelectedSalesRegion}
                        showSelectAll={true}
                        placeholder={t("visitreports.filters.selectRegion")}
                      />
                    </div>
                    <div className="w-1/2">
                      <DropdownMulti
                        label={t("visitreports.filters.salesOffice")}
                        options={
                          globalFilters?.sales_offices.map((sales: any) => ({
                            value: sales.id,
                            label: sales.name,
                          })) || []
                        }
                        selectedValues={salesOffice}
                        onClose={handleFiltersUpdate}
                        showSelectAll={true}
                        onChange={setSelectedSalesOffice}
                        disabled={salesRegion.length === 0 || loadingFilter}
                        placeholder={t(
                          "visitreports.filters.selectSalesOffice"
                        )}
                      />
                    </div>
                  </div>
                  <div >
                    {/* <div className="w-1/2">
                      <DropdownMulti
                        label={t("visitreports.filters.territoryID")}
                        options={
                          globalFilters?.territories?.map((emp: any) => ({
                            value: String(emp.territory_id),
                            label: emp.territory_identifier,
                          })) || []
                        }
                        selectedValues={teretorryId}
                        onChange={setTeretorryId}
                        onClose={handleFiltersUpdate}
                        disabled={salesRegion.length === 0 || loadingFilter}
                        placeholder={t(
                          "visitreports.filters.selectTerritoryID"
                        )}
                      />
                    </div> */}
                    <div >
                      <DropdownMulti
                        label={t("visitreports.filters.channelID")}
                        options={
                          (globalFilters?.channels || []).map((emp: any) => ({
                            value: `${emp.id}`,
                            label: emp.name,
                            disabled: !["20", "40", "50", "10","60"].includes(String(emp.id)),
                          }))
                        }
                        isSingleSelect={true}
                        selectedValues={channelId}
                        onChange={setChannelId}
                        onClose={handleFiltersUpdate}
                        // disabled={salesRegion.length === 0 || loadingFilter}
                        placeholder={t("visitreports.filters.selectChannelID")}
                      />
                    </div>
                  </div>
                  <div>
<DropdownMulti
                        label={t("visitreports.filters.supervisorID")}
                        options={
                          supervisorList.map((emp: any) => ({
                            value: emp.id,
                            label: emp.name_eng + " (" + emp.id + ")",
                          })) || []
                        }
                        selectedValues={supervisorId}
                        onChange={setSupervisorId}
                        searchable={true}
                        disabled={salesRegion.length === 0 || loadingFilter}
                        placeholder={t("visitreports.filters.supervisorID")}
                      />
                    </div>
                  <div className="flex gap-4">
                    <div className="w-1/2">
                      <DropdownMulti
                        label={t("ActivityReport.employeeName")}
                        options={
                          filteredEmployees.map((emp: any) => ({
                            value: emp.id,
                            label: emp.name_eng + " (" + emp.id + ")",
                          }))
                        }
                        selectedValues={emp}
                        onClose={handleFiltersUpdate}
                        onChange={setEmployee}
                        disabled={salesRegion.length === 0 || loadingFilter}
                        placeholder={t("ActivityReport.employeeName")}
                        searchable={true}
                      />
                    </div>
                    <div className="w-1/2">
                      <Dropdown
                        label={t("DashboardAnalytics.usertype")}
                        options={
                          globalFilters?.user_types.map((emp: any) => ({
                            value: emp,
                            label: emp,
                          })) || []
                        }
                        selectedValue={userType}
                        onChange={setUserType}
                        // disabled={!salesRegion || loadingFilter}
                        placeholder={t("DashboardAnalytics.usertype")}
                      />
                    </div>
                  </div>
                  <Dropdown
                    label={t("DashboardAnalytics.status")}
                    options={
                      globalFilters?.employee_status.map((emp: any) => ({
                        value: emp,
                        label: emp === "A" ? "Active" : "Inactive",
                      })) || []
                    }
                    selectedValue={selectedEmpStatus}
                    onChange={(value) => {
                      setSelectedEmpStatus((prev: any) => prev === value ? "" : value);
                    }}
                    // disabled={!salesRegion || loadingFilter}
                    placeholder={t("DashboardAnalytics.status")}
                  />
                  {/* <div className="w-full">
                    <div className="w-full">
                      <Dropdown
                        label={t("DashboardAnalytics.usertype")}
                        options={
                          globalFilters?.user_types.map((emp: any) => ({
                            value: emp,
                            label: emp,
                          })) || []
                        }
                        selectedValue={userType}
                        onChange={setUserType}
                        disabled={!salesRegion || loadingFilter}
                        placeholder={t("DashboardAnalytics.usertype")}
                      />
                    </div>
                  </div> */}
                  <div className="border border-gray-600 rounded-md p-2 pb-10 mt-2 relative">
                    <div className="date-range-picker space-y-2">
                      <div className="flex gap-4 justify-between w-full">
                        <div className="w-full">
                          <label className="block text-10 text-gray-700 mb-1">Year</label>
                          <Dropdown
                            label=""
                            options={dateRangeSelector.getQuarterYearOptions()}
                            selectedValue={dateRangeSelector.selectedYear}
                            onChange={handleYearDropdownChange}
                            placeholder="Select Year"
                            disabled={dateMode === "month"}
                          />
                        </div>
                        <div className="w-full">
                          <label className="block text-10 text-gray-700 mb-1">Quarter</label>
                          <Dropdown
                            label=""
                            options={dateRangeSelector.quarterOptions}
                            selectedValue={dateRangeSelector.selectedQuarter}
                            onChange={handleQuarterDropdownChange}
                            placeholder="Select Quarter"
                            disabled={dateMode === "month"}
                          />
                        </div>
                      </div>
                      <div className="flex gap-4 justify-between w-full">
                        <div className="w-full">
                          <label className="block text-10 text-gray-700 mb-1">Year</label>
                          <Dropdown
                            label=""
                            options={dateRangeSelector.getMonthYearOptions()}
                            selectedValue={dateRangeSelector.selectedMonthYear}
                            onChange={handleMonthYearDropdownChange}
                            placeholder="Select Year"
                            disabled={dateMode === "quarter"}
                          />
                        </div>
                        <div className="w-full">
                          <label className="block text-10 text-gray-700 mb-1">Month</label>
                          <Dropdown
                            label=""
                            options={dateRangeSelector.getAvailableMonths()}
                            selectedValue={dateRangeSelector.selectedMonth ? Number(dateRangeSelector.selectedMonth) : ""}
                            onChange={handleMonthDropdownChange}
                            placeholder="Select Month"
                            disabled={dateMode === "quarter"}
                          />
                        </div>
                      </div>
                      <div className="flex gap-4 justify-between w-full">
                        <div className="w-full">
                          <label className="block text-10 text-gray-700 mb-1">
                            {t("visitreports.filters.startDate")}:
                          </label>
                          <input
                            type="date"
                            className={`rounded p-2 border-2 border-gray-400 w-full ${dateMode === "quarter" || dateMode === "month" ? "bg-gray-100 text-gray-400 cursor-not-allowed opacity-70" : ""}`}
                            value={startDate}
                            onChange={handleStartDateChange}
                            onKeyDown={(e) => e.preventDefault()}
                            max={new Date().toISOString().split("T")[0]}
                            min="1970-01-01"
                            disabled={dateMode === "quarter" || dateMode === "month"}
                          />
                        </div>
                        <div className="w-full">
                          <label className="block text-10 text-gray-700 mb-1">
                            {t("visitreports.filters.endDate")}:
                          </label>
                          <input
                            type="date"
                            className={`rounded p-2 border-2 border-gray-400 w-full ${dateMode === "quarter" || dateMode === "month" ? "bg-gray-100 text-gray-400 cursor-not-allowed opacity-70" : ""}`}
                            max={(() => {
                              if (dateMode === "picker") {
                                const today = new Date();
                                const start = new Date(startDate);
                                const maxAllowedEndDate = new Date(start);
                                maxAllowedEndDate.setDate(start.getDate() + 30);
                                return maxAllowedEndDate <= today ? maxAllowedEndDate.toISOString().split("T")[0] : today.toISOString().split("T")[0];
                              }
                              return new Date().toISOString().split("T")[0];
                            })()}
                            min={(() => {
                              if (dateMode === "picker") {
                                return new Date(startDate).toISOString().split("T")[0];
                              }
                              return "1970-01-01";
                            })()}
                            value={endDate}
                            onChange={handleEndDateChange}
                            onKeyDown={(e) => e.preventDefault()}
                            disabled={dateMode === "quarter" || dateMode === "month"}
                          />
                        </div>
                      </div>
                      <div className="text-xs text-gray-500 mt-1">
                        {t("visitreports.filters.dateRangeNote", "Maximum date range: 31 days")}
                      </div>
                    </div>
                    <div className={`mt-3 ${dateMode !== "picker" ? "opacity-60 pointer-events-none" : ""}`}>
                      <TimeFrameSelector
                        customClass="w-full border border-gray-300 rounded p-2"
                        setSelectTimeFrame={(tf) => {
                          let newStart = startDate;
                          let newEnd = endDate;
                          if (tf === "Today") {
                            newStart = formatDate(new Date());
                            newEnd = formatDate(new Date());
                          } else if (tf === "Yesterday") {
                            newStart = formatDate(new Date(new Date().setDate(new Date().getDate() - 1)));
                            newEnd = formatDate(new Date(new Date().setDate(new Date().getDate() - 1)));
                          } else if (tf === "Month Till Date") {
                            newStart = formatDate(new Date(new Date().setDate(1)));
                            newEnd = formatDate(new Date());
                          }
                          setSelectTimeFrame(tf);
                          setStartDate(newStart);
                          setEndDate(newEnd);
                          // Only call global filter if not in initial mount
                          if (!isInitialMount) {
                            callGlobalFilterWithDates(newStart, newEnd, tf);
                          }
                        }}
                        timeFrame={timeFrame}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                      />
                    </div>
                    <button
                      type="button"
                      onClick={handleClearDateFilters}
                      className="absolute bottom-2 right-2 px-3 py-1 text-xs bg-gray-200 text-black rounded hover:bg-gray-300 transition-colors"
                    >
                      Clear
                    </button>
                  </div>
                </div>

                <div className="flex justify-between mt-4">
                  <button
                    onClick={handleClearFilters}
                    className="px-4 py-2 text-black bg-gray-200 rounded transition duration-200 hover:bg-gray-300"
                  >
                    {t("DashboardAnalytics.clearFilterButton")}
                  </button>
                  <button
                    onClick={() => handleApply(emp)}
                    className="px-4 py-2 text-white bg-purple rounded transition duration-200 hover:bg-[#F3E6F4] hover:text-purple"
                  >
                    {t("DashboardAnalytics.applyFilterButton")}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        <div
          className={`transition-all duration-300 ${isCollapsed ? "w-0 overflow-hidden" : "lg:max-w-[35%] w-full"
            } rounded relative  `}
        >
          <button
            onClick={toggleLeaderboard}
            className={`absolute top-1/2 z-30 px-2 py-6 bg-[#D099D4] text-white text-sm font-semibold 
      transform -translate-y-1/2 transition-all duration-300 ease-in-out hover:scale-105 
      focus:outline-none flex items-center space-x-2
      ${i18n.dir() === 'rtl' ? 'left-0' : 'right-[99.5%]'}
       hidden md:flex`}
          >
            <span>{isCollapsed ? '<' : '>'}</span>
          </button>
          {!isCollapsed && (
            <>
              <h2 className="text-base font-bold p-4 text-white bg-purple">
                {t("DashboardAnalytics.leaderboardTitle")}
              </h2>
              <div
                ref={scrollContainerRef}
                id="scroll-container"
                className="overflow-x-auto overflow-scroll h-[645px] md:h-[calc(100vh-130px)] scrollbar scrollbar-thin"
              >
                <LeaderTable
                  leaderData={leaderDataList}
                  loader={isLoading}
                  getIndex={getIndex}
                  setEmployee={(e) => handleEmployeeClick(e)}
                  selected={emp}
                  startDate={startDate}
                  endDate={endDate}
                />
              </div>
            </>
          )}
        </div>

        {isCollapsed && (

          <button
            onClick={toggleLeaderboard}
            style={!isCollapsed ? (i18n.dir() === "rtl" ? { right: "1%" } : { left: "1%" }) : {}}
            className={`absolute  ${i18n.dir() === "rtl" ? "right-[95%]" : "left-[98%]"} top-1/2 z-30 px-2 py-6 bg-[#D099D4] text-white text-sm font-semibold 
    transform -translate-y-1/2 transition-all duration-300 ease-in-out hover:scale-105 
    focus:outline-none flex items-center space-x-2  hidden md:flex
    `}
          >
            <span>{isCollapsed ? "<" : ">"}</span>
          </button>
        )}
      </div>
    </DashboardWrapper>
  );
};

export default Dashboard;
